import {twMerge} from '../../../common/twMerge';
import {ContentOverviewBackgroundImage} from '../ContentOverviewBackgroundImage/ContentOverviewBackgroundImage';
import {ContentOverviewProps} from './ContentOverviewProps.interface';

/**
 * 콘텐츠홈 상단 작품요약정보
 */
export function ContentOverview({
  children,
  thumbnailImageSrc,
  isMobile,
  className,
  ...props
}: ContentOverviewProps) {
  return (
    <div
      className={twMerge(
        'relative overflow-hidden',
        isMobile && 'w-screen pt-58pxr',
        !isMobile && 'h-326pxr w-320pxr pt-40pxr',
        className
      )}
      {...props}
    >
      {/* 배경 이미지 영역 */}
      {!isMobile && (
        <ContentOverviewBackgroundImage
          isMobile={isMobile}
          thumbnailImageSrc={thumbnailImageSrc}
        />
      )}
      <div className="relative h-full min-h-[inherit]">
        {/* 썸네일, 작품 BM 및 프로그레스 바를 나타낸다. */}
        {children}
      </div>
    </div>
  );
}
